import { styled } from '@linaria/react';
import { Group, Stack } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Divider } from '../../ui-library/divider/divider';
import { Icon } from '../../ui-library/icon/icon';
import { Text } from '../../ui-library/typography/typography';

type LegendItem = {
  icon: string;
  color: string;
  text: string;
  variant?: 'filled' | 'outlined';
};

export const ProcessGraphLegend = ({ legendItems }: { legendItems: LegendItem[] }) => {
  const [isOpen, { toggle }] = useDisclosure(false);
  return (
    <LegendContainer>
      <Group justify="space-between">
        <Text size="small" weight="bold">
          Legend
        </Text>
        <Icon name={isOpen ? 'expand_more' : 'expand_less'} size={20} onClick={toggle} />
      </Group>
      <LegendContent isOpen={isOpen}>
        <Divider style={{ margin: '8px 0' }} />
        <Stack gap="xs">
          {legendItems.map((item, index) => (
            <Group gap="xs" key={index}>
              <Icon name={item.icon} variant={item.variant ?? 'outlined'} size={20} color={item.color} />
              <Text size="tiny">{item.text}</Text>
            </Group>
          ))}
        </Stack>
      </LegendContent>
    </LegendContainer>
  );
};

const LegendContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 12px;  
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  z-index: 5;
  max-width: 200px;
  width: 100%;
  position: absolute;
  bottom: 15px;
  left: 2px;
`;

const LegendContent = styled.div<{ isOpen: boolean }>`
  max-height: ${(props) => (props.isOpen ? '200px' : '0')};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
`;
